export default {"src":"/_next/static/media/loader.b6d8d186.svg","height":390,"width":390,"blurWidth":0,"blurHeight":0};